export default "__VITE_ASSET__B0v7IFZH__"